__turbopack_context__.v({
  "profileImpact": "LAaJqW_profileImpact",
  "profileImpactCards": "LAaJqW_profileImpactCards",
});
